import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import domReady from '@wordpress/dom-ready';
import { ReactComponent as PlusBold } from './assets/plus-bold.svg';

interface FaqItem
	{
	id: number;
	question: string;
	answer: string;
	}

const FaqRow = ({ item, isOpen, onToggle }: { item: FaqItem, isOpen: boolean, onToggle: () => void }) =>
	{
	return (
		<div className={`wp-block-ocean-faq__item${isOpen ? ' is-open' : ''}`}>
			<h3 className="wp-block-ocean-faq__question-wrap">
				<button type="button" className="wp-block-ocean-faq__question" aria-expanded={isOpen} onClick={onToggle}>
					<span>{item.question}</span>
					<span className="wp-block-ocean-faq__icon" aria-hidden="true"><PlusBold /></span>
				</button>
			</h3>
			<div className="wp-block-ocean-faq__answer">
				<div className="wp-block-ocean-faq__answer-inner">
					<div className="wp-block-ocean-faq__answer-content" dangerouslySetInnerHTML={{ __html: item.answer }} />
				</div>
			</div>
		</div>
		);
	};

const BlockRuntime = ({ heading, items }: { heading: string, items: FaqItem[] }) =>
	{
	// One question open at a time, none open to start -- matches the closed
	// no-JS fallback rendered by render.php, so hydration doesn't cause a jump.
	const [openId, setOpenId] = useState<number | null>(null);

	return (
		<>
		<h2 className="wp-block-ocean-faq__heading">{heading}</h2>
		<div className="wp-block-ocean-faq__list">
			{items.map((item) => (
				<FaqRow
					key={item.id}
					item={item}
					isOpen={openId === item.id}
					onToggle={() => setOpenId(openId === item.id ? null : item.id)}
					/>
				))}
		</div>
		</>
		);
	};

domReady(() =>
	{
	const containers = document.querySelectorAll('.wp-block-ocean-faq');

	containers.forEach((container) =>
		{
		const dataset = (container as HTMLElement).dataset;
		const items: FaqItem[] = dataset.faq ? JSON.parse(dataset.faq) : [];
		const headingEl = container.querySelector('.wp-block-ocean-faq__heading');
		const heading = headingEl?.textContent || '';

		const root = createRoot(container);
		root.render(<BlockRuntime heading={heading} items={items} />);
		});
	});
